import Image from 'next/image';
import React from 'react';

export default function NoReply() {
  return (
    <div className="flex h-[200px] w-full flex-col items-center justify-center bg-apps-coreGray05">
      <Image
        width={60}
        height={60}
        src="/images/admin/common/icon-reply.svg"
        alt=""
      />
      <p className="text-sm font-medium text-apps-corePrimary01">
        작성된 댓글이 없습니다
      </p>
    </div>
  );
}
